import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Message } from 'primeng/api';
import { InputTextModule } from 'primeng/components/inputtext/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { UserService } from '../../services/user.service';
import { Router } from "@angular/router";
import { IUser } from "../../interfaces/User";

@Component({
  selector: 'app-show-user',
  templateUrl: './show-user.component.html',
  styleUrls: ['./show-user.component.css'],
  providers: [MessageService]
})
export class ShowUserComponent implements OnInit {
  rows: any[];
  cc: string = "";
  cols: any[];
  selectedUser: any;
  msgs: Message[] = [];
  displayDialog: boolean = false;
  data: IUser[];
  errorMsg: any;
  user: IUser = {};

  constructor(private messageService: MessageService,
    private router: Router,
    private userService: UserService,
    http: HttpClient) {

    userService.getUsers()
      .subscribe(
        data => this.rows = data,
      err => {
        this.messageService.add({ severity: 'error', summary: 'Error getting users', detail: err });
          console.error(err);
          this.errorMsg = <any>err;
      }
    );
}

  ngOnInit() {
    this.cols = [
      { field: 'userName', header: 'User Name' },
      { field: 'firstName', header: 'First Name' },
      { field: 'lastName', header: 'Last Name' },
      { field: 'company', header: 'Company' },
      { field: 'email', header: 'Email' },
      { field: 'companyCode', header: 'Company Code' },
      { field: 'isAdministrator', header: 'Administrator'}
    ];
  }

  onRowSelect(event) {
    console.log("Row selected" + event.data.userName);
    this.messageService.add({ severity: 'info', summary: 'User Selected', detail: 'User: ' + event.data.userName });
    this.user = this.cloneUser(event.data);
    this.displayDialog = true;
    this.selectedUser = null;
  }

  onRowUnselect(event) {
    console.log("Row unselected");
    this.messageService.add({ severity: 'success', sticky: false, summary: 'User Unselected', detail: 'User: ' + event.data.userName});
  }

  delete() {
    this.displayDialog = false;
    this.userService.deleteUser(this.user)
      .subscribe(
        data => {
          this.messageService.add({
            severity: 'success', summary: 'User Deleted', detail: 'User: ' + data.firstName + " " +
              data.lastName + " " + " (" + data.userName + ")"
          });
          this.userService.getUsers()
            .subscribe(
              data => this.rows = data,
              err => {
                this.messageService.add({ severity: 'error', summary: 'Error getting users', detail: err });
                console.error(err);
                this.errorMsg = <any>err;
              }
            );
        },
        err => {
          console.error(err);
          this.messageService.add({
            severity: 'fatal', summary: 'User NOT Deleted', detail: err.error
          });
        });
  }

  update() {
    this.displayDialog = false;
    this.userService.updateUser(this.user)
      .subscribe(
        data => {
          this.messageService.add({
            severity: 'success', summary: 'User Updated', detail: 'User: ' + data.firstName + " " +
              data.lastName + " " + " (" + data.userName + ")"
          });
          this.userService.getUsers()
            .subscribe(
              data => this.rows = data,
              err => {
                this.messageService.add({ severity: 'error', summary: 'Error getting users', detail: err });
                console.error(err);
                this.errorMsg = <any>err;
              }
            );
        },
        err => {
          console.error(err);
          this.messageService.add({
            severity: 'fatal', summary: 'User NOT Updated', detail: err.error
          });
        });
  }

  cloneUser(u: IUser): IUser {
    let user = {};
    for (let prop in u) {
      user[prop] = u[prop];
    }
    return user;
  }
}


